<template>
  <div>
    <el-table
      v-loading="moneyOrdersLoading"
      :data="moneyOrder.Items"
      style="width: 100%"
    >
      <el-table-column
        type="index"
        :index="orderIndexMethod"
        label="序号"
        width="50"
      ></el-table-column>
      <el-table-column property="UserName" label="购买人"> </el-table-column>
      <el-table-column
        label="购买时间"
        width="130"
        align="center"
        key="AddTime"
      >
        <template slot-scope="scope">
          <span>
            {{ scope.row.AddTime | dateformat('YYYY.MM.DD HH:mm') }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="购买次数" width="120" align="center" key="Num">
        <template slot-scope="scope">
          <span v-if="scope.row.AddType !== 5">{{ scope.row.Num }}</span>
          <span v-if="scope.row.AddType === 5">不限</span>
        </template>
      </el-table-column>
      <el-table-column
        label="购买金额"
        width="120"
        align="center"
        key="Realmoney"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.Realmoney }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="购买方式（支付宝、线下购买)"
        width="200"
        align="center"
        key="AddTypeText"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.AddTypeText }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination_box">
      <el-pagination
        background
        @size-change="moneyOrderHandleSizeChange"
        @current-change="moneyOrderHandleCurrentChange"
        :current-page.sync="moneyOrderCurrentPage"
        :page-size="moneyOrderQuery.maxResultCount"
        :layout="pagination_layout"
        :total="moneyOrder.TotalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: 'personal',
  data () {
    return {
      moneyOrdersLoading: true,
      moneyOrderQuery: {
        maxResultCount: 10,
        skipCount: 0
      },
      moneyOrderCurrentPage: 1,
      moneyOrder: {},
      pagination_layout: 'prev, pager, next'
    }
  },
  props: ['isCompanySystem'],
  methods: {
    getGetMoneyOrders: function () {
      const _this = this
      _this.moneyOrdersLoading = true
      _this.$api.moneyUsering.getGetMoneyOrders(_this.moneyOrderQuery).then(data => {
        _this.moneyOrder = data
        _this.moneyOrdersLoading = false
      }).catch(err => {
        _this.moneyOrdersLoading = false
        return err
      })
    },
    orderIndexMethod (index) {
      return this.moneyOrderQuery.skipCount + index + 1
    },
    moneyOrderHandleSizeChange (val) {
      this.moneyOrderQuery.maxResultCount = val
      this.getGetMoneyOrders()
    },
    moneyOrderHandleCurrentChange (val) {
      this.moneyOrderQuery.skipCount = (val - 1) * this.moneyOrderQuery.maxResultCount
      this.getGetMoneyOrders()
    }
  },
  created () {
    this.getGetMoneyOrders()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, prev, pager, next, jumper'
    }
  }
}
</script>
<style lang="less">
